<div class="portfolio-frame" id="portfolio">

    <div class="subtext-frame">
        <div class="sub-title">
            Records
        </div>
        <div class="text">
            <p [innerHTML]="listenText"></p>
        </div>
    </div>

    <div class="examples-frame" >
        <div class="img-text-frame left" [class.pic-change]="!isIOS" [class.ios]="isIOS">
            <div class="count-descript-frame song-list-trigger"
                role="button"
                tabindex="0"
                [class.open]="isSongListOpen"
                [attr.aria-expanded]="isSongListOpen"
                aria-controls="arrangements-song-list"
                (click)="toggleSongList()"
                (keydown.enter)="toggleSongList()"
                (keydown.space)="$event.preventDefault(); toggleSongList()">
                <div class="count">
                    <p><b>01/06</b></p>
                </div>
                <p class="text desc-l">Arrangements & Compositions</p>
                <p class="text desc-l" [innerHTML]="listenText"></p>
                <div class="song-list"
                    id="arrangements-song-list"
                    *ngIf="isSongListOpen"
                    (click)="$event.stopPropagation()">
                    <button class="close-song-list"
                        type="button"
                        aria-label="Songliste schließen"
                        (click)="closeSongList($event)">
                        X
                    </button>
                    <button class="song-item"
                        type="button"
                        *ngFor="let song of songs; let i = index"
                        [class.active]="i === selectedSongIndex"
                        (click)="playSong(i)">
                        <span>{{ (i + 1).toString().padStart(2, '0') }}</span>
                        <span>{{ song.title }}</span>
                    </button>
                    <audio #songPlayer class="song-player" controls [src]="songs[selectedSongIndex].src"></audio>
                </div>
            </div>
            <div class="rec-frame first-rec-frame"
                [class.hide-mobile]="isSongListOpen"
                role="button"
                tabindex="0"
                aria-controls="arrangements-song-list"
                [attr.aria-expanded]="isSongListOpen"
                (click)="openSongList()"
                (keydown.enter)="openSongList()"
                (keydown.space)="$event.preventDefault(); openSongList()">
                <div class="rectangle rect-left">
                    <div class="dot l">
                        <img src="assets/icons/arrow-left-32-white.png" alt="" class="arrow">
                    </div>
                </div>
                <img class="colored" src="assets/images/arranger-col.png" alt="">
                <img class="uncolored" src="assets/images/arranger-sw.png" alt="">
            </div>
        </div>

        <div class="img-text-frame right" [class.pic-change]="!isIOS" [class.ios]="isIOS">
            <a 
                href="https://www.youtube.com/watch?v=81JX-sn26yk" target="_blank">
                <div class="rec-frame">
                    <div class="rectangle">
                        <div class="dot r">
                            <img src="assets/icons/arrow-right-32-white.png" alt="" class="arrow">
                        </div>
                    </div>
                    <img class="colored" src="assets/images/marrana-col.png" alt="">
                    <img class="uncolored" src="assets/images/marrana-sw.png" alt="">
                </div>
            </a>
            <div class="count-descript-frame">
                <div class="count-right">
                    <p><b>02/06</b></p>
                </div>
                <div class="show-skills"></div>
                <p class="text desc-r" [innerHTML]="listenText"></p>
            </div>
        </div>

        <div class="img-text-frame left" [class.pic-change]="!isIOS" [class.ios]="isIOS">
            <div class="count-descript-frame">
                <div class="count">
                    <p><b>03/06</b></p>
                </div>
                <p class="text desc-l" [innerHTML]="listenText"></p>
            </div>
            <a href="https://www.youtube.com/watch?v=M4iAEGD0mhI" target="_blank">
                <div class="rec-frame">
                    <div class="rectangle rect-left">
                        <div class="dot l">
                            <img src="assets/icons/arrow-left-32-white.png" alt="" class="arrow">
                        </div>
                    </div>
                <img class="colored" src="assets/images/queensgang-col.png" alt="">
                <img class="uncolored" src="assets/images/queensgang-sw.png" alt="">
            </div>
            </a>
        </div>

        <div class="img-text-frame right" [class.pic-change]="!isIOS" [class.ios]="isIOS">
            <a href="https://www.youtube.com/watch?v=cxetnBib42I" target="_blank">
                <div class="rec-frame">
                    <div class="rectangle">
                        <div class="dot r">
                            <img src="assets/icons/arrow-right-32-white.png" alt="" class="arrow">
                        </div>
                    </div>
                <img class="colored" src="assets/images/cowboy-col.png" alt="">
                <img class="uncolored" src="assets/images/cowboy-sw.png" alt="">
            </div>
            </a>
            <div class="count-descript-frame">
                <div class="count-right">
                    <p><b>04/06</b></p>
                </div>
                <p class="text desc-r" [innerHTML]="listenText"></p>
            </div>
        </div>
    </div>

    <div class="img-text-frame left" [class.pic-change]="!isIOS" [class.ios]="isIOS">
        <div class="count-descript-frame">
            <div class="count">
                <p><b>05/06</b></p>
            </div>
            <p class="text desc-l" [innerHTML]="listenText"></p>
        </div>
        <a href="https://www.youtube.com/watch?v=7JUmg0WhYgc" target="_blank">
            <div class="rec-frame">
                <div class="rectangle rect-left">
                    <div class="dot l">
                        <img src="assets/icons/arrow-left-32-white.png" alt="" class="arrow">
                    </div>
                </div>
            <img class="colored" src="assets/images/fleischmann-col.png" alt="">
            <img class="uncolored" src="assets/images/fleischmann-sw.png" alt="">
        </div>
        </a>
    </div>
    <div class="img-text-frame right" [class.pic-change]="!isIOS" [class.ios]="isIOS">
        <a href="https://listen.music-hub.com/JfZD20" target="_blank">
            <div class="rec-frame">
                <div class="rectangle">
                    <div class="dot r">
                        <img src="assets/icons/arrow-right-32-white.png" alt="" class="arrow">
                    </div>
                </div>
            <img class="colored" src="assets/images/queensgang-v2-col.png" alt="">
            <img class="uncolored" src="assets/images/queensgang-v2-sw.png" alt="">
        </div>
        </a>
        <div class="count-descript-frame">
            <div class="count-right">
                <p><b>06/06</b></p>
            </div>
            <p class="text desc-r" [innerHTML]="listenText"></p>
        </div>
    </div>
</div>

    <div class="arrow-frame">
        <a href="#helloContact">
            <img class="arrow-left-down" src="assets/icons/arrow-left-pic.png" alt="arrow-left">
        </a>
    </div>
